import { Icon } from "./Icon.tsx";

/** "Zoom out" — GeoreferencedMap.tsx's own zoom control, paired with PlusIcon's "zoom in". */
export function MinusIcon() {
  return (
    <Icon>
      <path d="M5 12h14" />
    </Icon>
  );
}
